import { motion } from "framer-motion";
import { History, Download, Filter } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HistoryHeaderProps {
  onExport: () => void;
}

export const HistoryHeader = ({ onExport }: HistoryHeaderProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center justify-between mb-6 bg-gradient-to-r from-purple-50 to-purple-100 p-4 rounded-lg"
    >
      <div className="flex items-center gap-3">
        <History className="h-6 w-6 text-purple-500" />
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Trip History</h2>
          <p className="text-sm text-gray-600">View and analyze your past trips</p>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          className="flex items-center gap-2 bg-white hover:bg-purple-50"
          onClick={onExport}
        >
          <Download className="h-4 w-4" />
          Export
        </Button>
      </div>
    </motion.div>
  );
};